import { makeStyles } from '@material-ui/core'

export default makeStyles(() => ({
  editorBox: {
    fontSize: '16px',
    fontFamily: 'Arial, sans-serif !important',
    color: 'initial',

    '& *': {
      fontFamily: 'Arial, sans-serif !important',
    },
  },
}))
